import FontSizeRange from './FontSizeRange.vue';

export default FontSizeRange;
